import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid, Chip, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green, red } from "@material-ui/core/colors";

import HelperTooltip from "../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    width: "100%",
    height: "100%"
  }
}));

export const DimensionElement = ({ dimension }) => {
  const classes = useStyles();
  const dcmAds = useSelector((state) => state.dcmAds);
  const [chipColor, setChipColor] = useState(red[300]);
  const [tooltipText, setTooltipText] = useState(
    "No default creative detected for this placement size, click here to upload/assign one"
  );

  useEffect(() => {
    if (dcmAds.byId) {
      let defaultAdDimensions = Object.values(dcmAds.byId)
        .filter((ad) => ad.type === "AD_SERVING_DEFAULT_AD")
        .map((ad) => `${ad.size.width} x ${ad.size.height}`);

      defaultAdDimensions = [...new Set([...defaultAdDimensions])];

      if (defaultAdDimensions.includes(dimension)) {
        setChipColor(green[300]);
        setTooltipText("Default creative detected, no action needed");
      }
    }
  }, [dcmAds.byId, dimension]);

  return (
    <Tooltip title={tooltipText}>
      <Link
      
         style={{  textDecoration: "none"  }}
  
             to={`/default/${dimension.split(" ").join("")}`}
      
      >
        <Chip
          style={{ backgroundColor: chipColor }}
          label={dimension}
          onClick={()  =>  {}}
        />
      </Link>
    </Tooltip>
  );
};

export const DimensionDefaultList = () => {
  const classes = useStyles();
  const [placementDimensions, setDimensions] = useState([]);
  const dcmPlacements = useSelector((state) => state.dcmPlacements);

  useEffect(() => {
    let updatedDimensions = [];

    if (dcmPlacements.data) {
      for (let placement of dcmPlacements.data) {
        if (placement.size) {
          let dimension = `${placement.size.width} x ${placement.size.height}`;

          if (dimension !== "1 x 1") updatedDimensions.push(dimension);
        }
      }
    }

    updatedDimensions = [...new Set([...updatedDimensions])];
    setDimensions(updatedDimensions);
  }, [dcmPlacements, setDimensions]);

  return placementDimensions.length > 0 ? (
    <Grid container spacing={1} alignItems="center">
      {placementDimensions.map((d) => {
        return (
          <Grid key={d} item>
            <DimensionElement dimension={d} />
          </Grid>
        );
      })}
      <Grid item>
        <HelperTooltip
          tooltipText="These chips indicate the status of default creative dimensions assigned to the campaign. Red = No default assigned. Green = Default assigned.              Please select campaign defaults prior to assigning creatives to
          placements. NOTE: Video default ads take longer to activate in GCM"
        />
      </Grid>
    </Grid>
  ) : null;
};
